'use strict';

import 'sticky-sidebar';
import {throttle} from '../components/custom-lodash';

function isMobileOrTablet() {
    return $(window).width() <= 1023;
}

function initStickyPanel() {
    let stickyContent = '#product-content';
    const containerSelector = '#panelTabsContainerDesktop';
    const $productSet = $('#product-set-list');
    const $cosmetics = $('.pdp-cosmetics');
    const headerHeight = $('.header-wrapper.only-on-desktop').outerHeight();

    let bottomSpacing = 26;
    let topSpacing = 114;
    let windowHeight = $(window).height();
    let containerHeight = $(stickyContent).outerHeight();

    if (windowHeight - headerHeight < containerHeight) {
        topSpacing = 0;
    }

    if ($productSet && $productSet.length) {
        stickyContent = '#product-set-list';
        bottomSpacing = 156;
        topSpacing = -150;
    }

    if ($cosmetics && $cosmetics.length && topSpacing === 0) {
        topSpacing = $(window).height() - $(stickyContent).outerHeight();
    }

    var stickyConfig = {
        containerSelector: containerSelector,
        topSpacing: topSpacing,
        bottomSpacing: bottomSpacing
    };

    window.stickySidebar = new StickySidebar(stickyContent, stickyConfig);
}

function reInitStickyPanel() {
    if (window.stickySidebar) {
        window.stickySidebar.destroy();
        window.stickySidebar = null;
    }
    initStickyPanel();
}

function updateStickyPanel() {
    if (window.stickySidebar) {
        window.stickySidebar.updateSticky();
    }
}

module.exports = {
    init: function () {
        var isMobileOrIsTablet = isMobileOrTablet();

        if (!isMobileOrIsTablet) {
            if (!window.stickySidebar) {
                $(window).on('load', function () {
                    initStickyPanel();
                });
            } else {
                reInitStickyPanel();
                updateStickyPanel();
            }
        }

        $(window).on(
            'resize',
            throttle(function (e) {
                isMobileOrIsTablet = isMobileOrTablet();
                if (isMobileOrIsTablet) {
                    if (window.stickySidebar) {
                        window.stickySidebar.destroy();
                    }
                } else {
                    reInitStickyPanel();
                    updateStickyPanel();
                }
            }, 100)
        );
    },

    scrollToContent: function () {
        if (!isMobileOrTablet()) {
            const $productSet = $('#product-set-list');
            const $pdpMain = $('#pdpMain');
            if ($pdpMain.hasClass('pdp-cosmetics') || ($productSet && $productSet.length)) {
                return;
            }

            var headerHeight = $('.header-wrapper').outerHeight();

            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            var $addToCart = $('#add-to-cart');
            var addToCartTop = $addToCart.offset().top;
            var addToCartBottom = addToCartTop + $addToCart.outerHeight();
            var isAddToCartInViewport = addToCartBottom > viewportTop && addToCartBottom < viewportBottom;

            var $sticky = $('.inner-wrapper-sticky');
            var stickyTop = $sticky.offset().top;
            var stickyBottom = stickyTop + $sticky.outerHeight();
            var stickyVisibleTop = stickyTop < viewportTop ? viewportTop : stickyTop;
            var stickyVisibleBottom = stickyBottom > viewportBottom ? viewportBottom : stickyBottom;
            var stickyUnvisibleHeight = $sticky.outerHeight() - (stickyVisibleBottom - stickyVisibleTop);

            if (!isAddToCartInViewport && $('.sizes-wrapper').is(':visible')) {
                if (stickyUnvisibleHeight > stickyTop - headerHeight) {
                    $('html,body').animate(
                        {
                            scrollTop: viewportTop + stickyUnvisibleHeight + 26
                        },
                        {
                            duration: 300,
                            complete: function () {
                                reInitStickyPanel();
                                updateStickyPanel();
                            }
                        }
                    );
                } else {
                    $('.inner-wrapper-sticky').animate(
                        {
                            top: viewportBottom - stickyBottom - 26
                        },
                        {
                            duration: 300,
                            complete: function () {
                                reInitStickyPanel();
                                updateStickyPanel();
                            }
                        }
                    );
                }
            } else {
                $(window).one(
                    'scroll',
                    throttle(function () {
                        if (!isMobileOrTablet()) {
                            reInitStickyPanel();
                            updateStickyPanel();
                        }
                    }, 100)
                );
            }
        }
    }
};
